module.exports = __webpack_public_path__ + "static/media/Serviceactive.a2bad019.png";